export default __webpack_public_path__ + "static/media/splash-icon.a5a64349.png";